import "./config";  // load global config first
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";
import TheSeaLayout from "./Components/the-sea/TheSeaLayout";
import { TheSeaProvider } from "./Components/the-sea/TheSeaContext";
import TheSeaHome from "./Components/the-sea/TheSeaHome";
import TheSeaAbout from "./Components/the-sea/TheSeaAbout";
import TheSeaBlog from "./Components/the-sea/TheSeaBlog";
import TheSeaPrivacy from "./Components/the-sea/TheSeaPrivacy";
import TheSeaTerms from "./Components/the-sea/TheSeaTerms";
import TheSeaAccount from "./Components/the-sea/TheSeaAccount";
import TheSeaLoginSignup from "./Components/the-sea/TheSeaLoginSignup";
import PointPurchase from "./Components/the-sea/PointPurchase";
import PointPurchaseSucceeded from "./Components/the-sea/PointPurchaseSucceeded";
import PointPurchaseCanceled from "./Components/the-sea/PointPurchaseCanceled";

function App() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

      {/* Navbar at the top (The Sea renders its own header) */}
      {/* MeHire routes are disabled, so MeHire's own header is disabled too */}
      {/* {!isTheSea && <NavBar />} */}

      {/* Main content grows to fill remaining space */}
      <main style={{ flex: 1 }}>
        <ScrollToTop />
        <Routes>
          {/* The Sea — now the site's home, with its own header/footer */}
          <Route path="/" element={<TheSeaProvider><TheSeaLayout /></TheSeaProvider>}>
            <Route index element={<TheSeaHome />} />
            <Route path="about" element={<TheSeaAbout />} />
            <Route path="blog" element={<TheSeaBlog />} />
            <Route path="privacy" element={<TheSeaPrivacy />} />
            <Route path="terms" element={<TheSeaTerms />} />
            <Route path="account" element={<TheSeaAccount />} />
            <Route path="loginsignup" element={<TheSeaLoginSignup />} />
            <Route path="points" element={<PointPurchase />} />
            <Route path="points/succeeded" element={<PointPurchaseSucceeded />} />
            <Route path="points/canceled" element={<PointPurchaseCanceled />} />
          </Route>

          {/* Protected pages */}
          {/*
          <Route path="/customerdashboard" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
          <Route path="/providerdashboard" element={<ProtectedRoute><ProviderDashboard /></ProtectedRoute>} />
          <Route path="/search" element={<ProtectedRoute><Search /></ProtectedRoute>} />
          <Route path="/mytasks" element={<ProtectedRoute><MyTasks /></ProtectedRoute>} />
          <Route path="/profilesearch" element={<ProtectedRoute><ProfileSearch /></ProtectedRoute>} />
          <Route path="/createtask" element={<ProtectedRoute><CreateTask /></ProtectedRoute>} />
          <Route path="/candidates" element={<ProtectedRoute><Candidates /></ProtectedRoute>} />
          <Route path="/candidatedetail" element={<ProtectedRoute><CandidateDetail /></ProtectedRoute>} />
          <Route path="/reviewcandidate" element={<ProtectedRoute><ReviewCandidate /></ProtectedRoute>} />
          <Route path="/mywork" element={<ProtectedRoute><MyWork /></ProtectedRoute>} />
          <Route path="/myreviews" element={<ProtectedRoute><MyReviews /></ProtectedRoute>} />
          <Route path="/myprofile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
          <Route path="/customersettings" element={<ProtectedRoute><CustomerSettings /></ProtectedRoute>} />
          <Route path="/providersettings" element={<ProtectedRoute><ProviderSettings /></ProtectedRoute>} />

          <Route
            path="/customersubscription"
            element={
              <Elements stripe={stripePromise}>
                <ProtectedRoute><CustomerSubscription /></ProtectedRoute>
              </Elements>
            }
          />

          <Route
            path="/providersubscription"
            element={
              <Elements stripe={stripePromise}>
                <ProtectedRoute><ProviderSubscription /></ProtectedRoute>
              </Elements>
            }
          />

          <Route path="/customersubscriptionsucceeded" element={<ProtectedRoute><CustomerSubscriptionSucceeded /></ProtectedRoute>} />
          <Route path="/customersubscriptioncanceled" element={<ProtectedRoute><CustomerSubscriptionCanceled /></ProtectedRoute>} />
          <Route path="/providersubscriptionsucceeded" element={<ProtectedRoute><ProviderSubscriptionSucceeded /></ProtectedRoute>} />
          <Route path="/providersubscriptioncanceled" element={<ProtectedRoute><ProviderSubscriptionCanceled /></ProtectedRoute>} />
          */}

          {/* Catch-all redirect to the site's home (The Sea) if route not found */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {/* Footer sticks to the bottom if content is short (The Sea renders its own footer) */}
      {/* MeHire routes are disabled, so MeHire's own footer is disabled too */}
      {/* {!isTheSea && <Footer />} */}
    </div>
  );
}

export default App;

// Some useful icons: ✅  👍  👈  🧠  💪 🎯 🟢  👇  😄 
// Other icons: https://icons8.com/icons/set/active-icon--static--green

